<template>
  <!--图层操作组件 -->
  <transition name="el-fade-in-linear">
    <div
      class="divliebiaor"
      v-show="dialogFormVisible"
    >

      <div class="divliebiaoright">
        <div class="listhead">
          <div class="listtitle">图层</div>
          <div class="closed"><i
              class="el-icon-close"
              @click="closed"
            ></i></div>
        </div>
        <div class="listbody">
          <div
            class="listcheckall"
            style="padding-right: 12px;"
          >
            <el-checkbox
              v-model="checked"
              @change="call"
            ><span>显示</span></el-checkbox>
            <span
              @click="selectaddall(1,$event)"
              style="font-size: 14px;color: #18bc9c;cursor: pointer;line-height: 2.0;"
            >清空</span>
          </div>
          <div
            class="gundong mt"
            style="height: 94%;"
          >
            <draggable
              v-model="dynamicTags"
              @update="datadragEnd"
            >
              <transition-group id="tcdong">
                <div
                  class="bhover listcheckbody addborder"
                  v-for="(item,index) in dynamicTags"
                  :layerurl="item.tile_url"
                  :layerUrlIndex="index"
                  :key="item.product_id"
                  :id="item.product_id"
                >
                  <div class="cartlisttitle">
                    <el-checkbox
                      v-model="item.tccheckall"
                      @change="zicheck(item.tccheckall,index,item)"
                      style="width: 60%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"
                    >
                      {{item.product_file_name}}
                    </el-checkbox>
                    <i
                      class="el-icon-delete mt5"
                      @click="selectinfoadd(index,$event)"
                    ></i>

                    <i
                      class="el-icon-thirdcolor"
                      v-if="swtichtype(item) != 'shp'"
                      @click="selectinfoopen(item,$event)"
                    >{{item.tctype}}</i>
                  </div>
                  <div class="cartlistbody"><span>{{item.product_date}}</span></div>
                  <div
                    class="cartlistbody widthbody closedtcc"
                    style="flex-flow: wrap;padding-left: 0px;"
                  >
                    <div style="width:73%;margin-left: 12%;">
                      <el-slider
                        v-model="item.optionf"
                        @change="slchange(item,item.optionf)"
                        :show-tooltip="false"
                      ></el-slider>
                    </div>
                    <div style="width:10%;text-align: right;line-height: 2.2;"><span>{{item.optionf/100}}</span></div>
                  </div>
                  <div
                    class="cartlistbody widthbody closedtcc"
                    style="padding-left: 0px;"
                  >
                    <div class="colorlist">
                      <div
                        class="colorborder"
                        @click="setcolor(item,$event,'cool')"
                      >
                        <div
                          class="colorcard"
                          style="background-color: pink;"
                        ></div>
                      </div>
                      <div
                        class="colorborder"
                        @click="setcolor(item,$event,'plasma')"
                      >
                        <div
                          class="colorcard"
                          style="background-color: yellow;"
                        ></div>
                      </div>
                      <div
                        class="colorborder"
                        @click="setcolor(item,$event,'greys')"
                      >
                        <div
                          class="colorcard"
                          style="background-color: gray;"
                        ></div>
                      </div>
                      <div
                        class="colorborder"
                        @click="setcolor(item,$event,'rainbow')"
                      >
                        <div
                          class="colorcard"
                          style="background-color: red;"
                        ></div>
                      </div>
                      <div
                        class="colorborder"
                        @click="setcolor(item,$event,'winter')"
                      >
                        <div
                          class="colorcard"
                          style="background-color: green;"
                        ></div>
                      </div>

                    </div>
                    <!-- <div style="flex-flow: wrap;display: flex;margin-top: 10px;">
                      <div style="width:12%;text-align: left;line-height: 2.2;"><span>{{item.colorl[0]*10}}</span></div>
                      <div style="width:73%;">
                        <el-slider
                          v-model="item.colorl"
                          :show-tooltip="false"
                          @change="slchangehdz(item,item.colorl)"
                          range
                        ></el-slider>
                      </div>
                      <div style="width:15%;text-align: right;line-height: 2.2;"><span>{{item.colorl[1]*10}}</span></div>
                    </div> -->
                    <div style="flex-flow: wrap;display: flex;">
                      <div style="width:73%;margin-left: 12%;">
                        <el-slider
                          v-model="item.optionf"
                          @change="slchange(item,item.optionf)"
                          :show-tooltip="false"
                        ></el-slider>
                      </div>
                      <div style="width:15%;text-align: right;line-height: 2.0;"><span>{{item.optionf/100}}</span></div>
                    </div>

                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>

        </div>
      </div>
    </div>

  </transition>

</template>

<script>
import Map from '../../common/map/Tmap.js'
import draggable from 'vuedraggable'
export default {
  components: {
    draggable
  },
  name: 'HeadProductTuCengDialog',
  props: ['msgFather', 'prodata'],
  data () {
    return {
      dialogFormVisible: false,
      dynamicTags: [],
      isshow: false,
      checked: true,
      optionf: 1,
      colorl: [0, 1000],
      gwc: [],
      jbo: []
    }
  },
  // 初始化数据
  created () {
    this.dynamicTags = this.prodata
    this.dialogFormVisible = this.msgFather
  },
  methods: {
    slchangehdz (item, val) {
      Map.SetLayerXrang(item.product_id, val)
    },
    slchange (item, val) {
      Map.SetLayerOpacity(item.product_id, val)
    },
    setcolor (val, e, type) {
      let et = e.currentTarget
      let childrens = et.parentNode.children
      console.log(childrens)
      for (let i = 0; i < childrens.length; i++) {
        childrens[i].className = 'colorborder'
      }
      if (et.className === 'colorborder') {
        et.className = 'colorborderis'
        Map.SetLayerColor(type, val.product_id)
      }
    },
    selectinfoopen (val, e) {
      let et = e.currentTarget
      let etp
      if (et.style.color === 'rgb(24, 188, 156)') {
        et.style.color = '#ccc'
      } else {
        et.style.color = 'rgb(24, 188, 156)'
      }
      if (this.swtichtype(val) === 'png') {
        etp = et.parentNode.parentNode.children[2]
        if (etp.className === 'cartlistbody widthbody closedtcc') {
          etp.className = 'cartlistbody widthbody'
        } else {
          etp.className = 'cartlistbody widthbody closedtcc'
        }
      } else if (this.swtichtype(val) === 'qt') {
        etp = et.parentNode.parentNode.children[3]
        if (etp.className === 'cartlistbody widthbody closedtcc') {
          etp.className = 'cartlistbody widthbody'
        } else {
          etp.className = 'cartlistbody widthbody closedtcc'
        }
      }
    },
    // 图层拖拽方法
    datadragEnd (evt) {
      var cj
      var movelength
      var movearr
      var newindex
      if (evt.newIndex > evt.oldIndex) {
        console.log('下移')
        movelength = evt.newIndex - evt.oldIndex
        cj = Map.GetLayerByName('Layer' + evt.item.id)
        newindex = (Number(cj.getZIndex()) - Number(movelength))
        cj.setZIndex(newindex)
        movearr = this.dynamicTags.slice(evt.oldIndex, evt.newIndex)
        movearr.forEach(item => {
          var layer = Map.GetLayerByName('Layer' + item.product_id)
          layer.setZIndex(layer.getZIndex() + 1)
        })
      } else if (evt.newIndex < evt.oldIndex) {
        console.log('上移')
        movelength = evt.oldIndex - evt.newIndex
        cj = Map.GetLayerByName('Layer' + evt.item.id)
        newindex = (Number(cj.getZIndex()) + Number(movelength))
        cj.setZIndex(newindex)
        movearr = this.dynamicTags.slice(evt.newIndex + 1, evt.oldIndex + 1)
        movearr.forEach(item => {
          var layer = Map.GetLayerByName('Layer' + item.product_id)
          layer.setZIndex(layer.getZIndex() - 1)
        })
      }
    },
    totalamount () {
      var total = 0
      this.jbo.forEach(el => {
        total += 1
      })
      return total
    },
    zicheck (val, index, item) {
      if (val) {
        this.jbo.push(item)
        Map.SetLayerVisible(item.product_id, val)
        this.dynamicTags[index].tccheckall = true
      } else {
        this.dynamicTags[index].tccheckall = false
        Map.SetLayerVisible(item.product_id, val)
        if (this.jbo.length > 0) {
          this.jbo.forEach((ee, ind) => {
            if (ee.product_id === item.product_id) {
              this.jbo.splice(ind, 1)
            }
          })
        }
      }
      var ck = true
      this.dynamicTags.forEach(el => {
        if (el.tccheckall) {
          this.isshow = true
        } else {
          ck = false
        }
      })
      this.checked = ck
      this.$emit('sendclearall', this.dynamicTags)
    },
    call () {
      this.jbo = []
      if (this.checked) {
        this.dynamicTags.forEach(el => {
          el.tccheckall = true
          Map.SetLayerVisible(el.product_id, true)
          this.isshow = true
          this.jbo.push(el)
        })
      } else {
        this.dynamicTags.forEach(el => {
          el.tccheckall = false
          Map.SetLayerVisible(el.product_id, false)
          this.isshow = false
          this.jbo = []
        })
      }
    },
    selectaddall (val, e) {
      console.log('清空')
      this.dynamicTags.forEach(el => {
        var name = 'Layer' + el.product_id
        Map.RemoveLayerByName(name)
      })
      this.dynamicTags = []
      this.checked = false
      this.jbo = []
      this.$emit('sendclearalltc', this.dynamicTags)
    },
    selectinfoshow (val, e) {
      if (e.currentTarget.style.color === 'rgb(24, 188, 156)') {
        e.currentTarget.style.color = '#ccc'
      } else {
        e.currentTarget.style.color = '#18bc9c'
      }
    },
    selectinfoadd (index, e) {
      console.log('删除图层：')
      if (e.currentTarget.style.color === 'rgb(24, 188, 156)') {
        e.currentTarget.style.color = '#ccc'
      } else {
        e.currentTarget.style.color = '#18bc9c'
      }

      if (this.jbo.length > 0) {
        this.jbo.forEach((ee, ind) => {
          if (ee.product_id === this.dynamicTags[index].product_id) {
            this.jbo.splice(ind, 1)
          }
        })
      }
      var name = 'Layer' + this.dynamicTags[index].product_id
      this.dynamicTags.splice(index, 1)
      console.log('删除图层：' + name)
      Map.RemoveLayerByName(name)
      if (this.dynamicTags.length === 0) {
        this.checked = false
      }

      this.$emit('sendclearalltc', this.dynamicTags)
    },
    sendMsgToParent () {
      this.$emit('getproducttucengdialogFormVisible', this.dialogFormVisible)
    },
    closed (e) {
      this.dialogFormVisible = false
      var hob = e.currentTarget.parentNode.parentNode.parentNode.lastChild.lastChild.getElementsByTagName('i')
      for (var i = 0; i < hob.length; i++) {
        hob[i].style.color = '#ccc'
      }
      this.checked = false
      this.isshow = false
    },
    swtichtype (val) {
      if (val.tile_image_type && val.tile_image_type.toLowerCase() === 'png') {
        return 'png'
      } else if (val.data_format.toLowerCase() === 'shp') {
        return 'shp'
      } else {
        return 'qt'
      }
    }
  },
  watch: {
    msgFather (curVal) {
      this.dialogFormVisible = curVal
    },
    dialogFormVisible () {
      this.sendMsgToParent()
    },
    prodata (data) {
      this.dynamicTags = data
    }
  }
}
</script >
<style >
.colorlist {
  width: 100%;
  flex-flow: column;
  display: flex;
}
.colorlist .colorborder {
  width: 100%;
  height: 20px;
  margin-top: 5px;
  cursor: pointer;
  padding: 2px;
  background-color: #fff;
}
.colorlist .colorborder:hover {
  width: 100%;
  height: 20px;
  background-color: #ccc;
}
.colorlist .colorborderis {
  width: 100%;
  height: 20px;
  margin-top: 5px;
  cursor: pointer;
  padding: 2px;
  background-color: #ccc;
}
.colorlist .colorborderis:hover {
  width: 100%;
  height: 20px;
  background-color: #ccc;
}
.colorlist .colorcard {
  width: 100%;
  height: 18px;
  margin-top: 1px;
  background-color: red;
  border-radius: 4px;
}
.el-slider__button {
  width: 12px;
  height: 12px;
  border: 1px solid #18bc9c;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.2s;
  user-select: none;
}
.el-slider__bar {
  height: 4px;
  background-color: #18bc9c;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  position: absolute;
}
.el-slider__button-wrapper {
  height: 16px;
  width: 16px;
  position: absolute;
  z-index: 1001;
  top: -7px;
  background-color: transparent;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: normal;
}
.el-slider__runway {
  width: 100%;
  height: 4px;
  margin: 12px 0;
  background-color: #e4e7ed;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
}
.widthbody {
  width: 100%;
}
.cartlistbody {
  display: flex;
  flex-flow: column;
  font-size: 12px;
  text-align: left;
  padding-left: 25px;
  line-height: 1.8;
  color: rgb(24, 188, 156);
}
.cartlisttitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.closedtcc {
  display: none;
}
.zidingy .el-button:focus {
  color: #fff;
  border-color: red;
  font-size: 12px;
  background-color: red;
  border-radius: 0px;
  padding: 10px;
  width: 80%;
}
.zidingy .el-button:hover {
  color: #fff;
  border-color: red;
  font-size: 12px;
  background-color: red;
  border-radius: 0px;
  padding: 10px;
  width: 80%;
}
.zidingy .el-button {
  background-color: red;
  border-color: red;
  font-size: 12px;
  color: #fff;
  border-radius: 0px;
  padding: 10px;
  width: 80%;
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background-color: #fff;
}
::-webkit-scrollbar-thumb {
  background-color: #18bc9c;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #18bc9c;
}
::-webkit-scrollbar-thumb:active {
  background-color: #18bc9c;
}
.gundong {
  overflow-y: auto;
  overflow-x: hidden;
  height: 94%;
}
.listcheckall {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 48px;
  padding-top: 10px;
}
.mt .listcheckall i {
  margin-top: 5px;
  color: #18bc9c;
  cursor: pointer;
}
.mt .addborder {
  background-color: #fff;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  padding-left: 15px;
  border-radius: 2px;
  border: 1px #ccc solid;
  box-shadow: 1px 1px 1px 1px #ccc;
}
.mt .listcheckbody {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 12px;
  padding-top: 5px;
}
.mt .listcheckbody i {
  margin-top: 0px;
  color: #ccc;
  cursor: pointer;
}
.mt .listcheckbody i:hover {
  margin-top: 0px;
  color: #18bc9c;
  cursor: pointer;
}
.is_active {
  margin-top: 5px;
  color: #18bc9c;
  cursor: pointer;
}
.listbody {
  height: 94%;
}
.listhead {
  display: flex;
  background-color: #191b2e;
  height: 20px;
  padding: 10px;
  justify-content: space-between;
  color: #fff;
  font-size: 14px;
}
.divliebiaor {
  background-color: #191b2e;
  width: 300px;
  height: 100%;

  margin-right: 60px;
}
.divliebiaoright {
  width: 300px;
  height: 100%;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/RightMenu/HeadProductTuCengDialog.vue